export const SELECT_CLIENT_MODAL_SELECTION_MODE = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
} as const;

export type SelectClientModalSelectionMode =
  (typeof SELECT_CLIENT_MODAL_SELECTION_MODE)[keyof typeof SELECT_CLIENT_MODAL_SELECTION_MODE];

export const SELECT_CLIENT_MODAL_TITLES: Record<SelectClientModalSelectionMode, string> = {
  [SELECT_CLIENT_MODAL_SELECTION_MODE.SINGLE]: 'Select client',
  [SELECT_CLIENT_MODAL_SELECTION_MODE.MULTIPLE]: 'Select clients',
};

export const CLIENT_SELECTION_ACTION = {
  AIR_REQUEST: 'airRequest',
  SEND_FORMS: 'sendForms',
  EXPORT_CLIENT: 'exportClient',
} as const;

export type ClientSelectionAction = (typeof CLIENT_SELECTION_ACTION)[keyof typeof CLIENT_SELECTION_ACTION];

export const CLIENT_SELECTION_ACTION_SELECTION_MODE: Record<ClientSelectionAction, SelectClientModalSelectionMode> =
  {
    [CLIENT_SELECTION_ACTION.AIR_REQUEST]: SELECT_CLIENT_MODAL_SELECTION_MODE.SINGLE,
    [CLIENT_SELECTION_ACTION.SEND_FORMS]: SELECT_CLIENT_MODAL_SELECTION_MODE.SINGLE,
    [CLIENT_SELECTION_ACTION.EXPORT_CLIENT]: SELECT_CLIENT_MODAL_SELECTION_MODE.MULTIPLE,
  };

export const SELECT_CLIENT_MODAL_COPY: Record<
  ClientSelectionAction,
  {
    description: string;
    errorMessage: string;
    submittingLabel: string;
    submitLabel?: string;
    successMessage?: string;
    withEmail?: boolean;
  }
> = {
  [CLIENT_SELECTION_ACTION.AIR_REQUEST]: {
    description: 'Select the client you want to create a new air request for.',
    errorMessage: 'Could not create air request. Please try again.',
    submittingLabel: 'Creating...',
  },
  [CLIENT_SELECTION_ACTION.SEND_FORMS]: {
    description: 'Select the client who should receive the profile and credit card forms.',
    errorMessage: 'Could not send forms. Please try again.',
    submittingLabel: 'Sending...',
    successMessage: 'Forms were sent successfully.',
    withEmail: true,
  },
  [CLIENT_SELECTION_ACTION.EXPORT_CLIENT]: {
    description: 'Search and select one or more clients to export.',
    errorMessage: 'Could not open export settings. Please try again.',
    submittingLabel: 'Continuing...',
    submitLabel: 'Continue',
  },
};
